import React from 'react';

export default function Loader({ style, text = null }) {
  return (
    <span style={{ ...style }}>
      <i className="fa fa-spinner fa-spin" aria-hidden="true" /> {text}
    </span>
  );
}
